'use es6';

import { getMessageDeleteStatus } from './commonMessageFormatGetters';
import { SOFT_DELETED } from '../constants/messageDeleteStatus';
export const isMessageSoftDeleted = message => getMessageDeleteStatus(message) === SOFT_DELETED;